// extracted by mini-css-extract-plugin
module.exports = {"loading":"ChatBotLoading_loading__kII4F","image":"ChatBotLoading_image__EwX1D","fadeOut":"ChatBotLoading_fadeOut__o6SR_","fade-out":"ChatBotLoading_fade-out__tyqYP"};